export default __webpack_public_path__ + "static/media/bscHover.e227cc91.svg";